export default __webpack_public_path__ + "static/media/ellipse_ressources.74354246.svg";